module.exports = __webpack_public_path__ + "img/pdgt_mkr.0f9490e6.jpg";